export default "__VITE_ASSET__CNuL2JTl__"